import React from 'react';

const AboutPage = () => {
  return (
    <div>
      <h1>About Us</h1>
      <p>This is the About Page of our service provider application.</p>
    </div>
  );
};

export default AboutPage;
